export enum MonthOrLifeTime {
  month = 'MONTH',
  kmOrLifetime = 'KM_OR_LIFETIME',
}

export interface CrmMatrixSettings {
  antecedenceDaysSendEmailBirthday: number;
  birthdayAutomaticSend: boolean;
  customerWithoutMovementAutomaticSend: boolean;
  daysAfterBillExpired: number;
  futureServicesAutomaticSend: boolean;
  id: number;
  matrixId?: number;
  nextReviewsAutomaticSend: boolean;
  recoveryDebtsAutomaticSend: boolean;
  satisfactionSurveyAutomaticSend: boolean;
}

export interface CrmMatrixFormValues {
  monthOrLifeTime: MonthOrLifeTime;
  nextReviewMonth: number;
  sendAutomaticNotification: boolean;
  birthdayAutomaticSend: boolean;
  customerWithoutMovementAutomaticSend: boolean;
  futureServicesAutomaticSend: boolean;
  nextReviewsAutomaticSend: boolean;
  recoveryDebtsAutomaticSend: boolean;
  satisfactionSurveyAutomaticSend: boolean;
}

export interface CrmMatrixSettingsUpdate {
  antecedenceDaysSendEmailBirthday?: number;
  birthdayAutomaticSend: boolean;
  customerWithoutMovementAutomaticSend: boolean;
  daysAfterBillExpired?: number;
  futureServicesAutomaticSend: boolean;
  id: number;
  nextReviewsAutomaticSend: boolean;
  recoveryDebtsAutomaticSend: boolean;
  satisfactionSurveyAutomaticSend: boolean;
}
